import React from "react";
import { Star, ChevronRight } from "lucide-react";

export const ModelRoute = ({ recommended, alternatives = [] }) => (
    <div
        data-testid="model-route-card"
        className="border border-slate-200 bg-white rounded-sm hover-lift"
    >
        <div className="px-8 pt-8 pb-6 border-b border-slate-200 bg-slate-900 text-slate-50 rounded-t-sm">
            <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-300">
                <Star className="h-3.5 w-3.5" />
                Recommended route
            </div>
            <div className="mt-3 font-heading text-2xl lg:text-3xl font-semibold tracking-tight">
                {recommended?.summary}
            </div>
            <p className="mt-3 text-sm text-slate-300 max-w-3xl leading-relaxed">
                {recommended?.cost_rationale}
            </p>
        </div>
        <div className="px-8 py-6">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500 mb-3">
                Alternatives considered
            </div>
            <ul className="divide-y divide-slate-200">
                {alternatives.map((alt) => (
                    <li
                        key={alt.id}
                        data-testid={`route-alt-${alt.id}`}
                        className="flex items-center gap-3 py-3"
                    >
                        <ChevronRight className="h-4 w-4 text-slate-400" />
                        <span className="text-sm text-slate-700 flex-1">{alt.label}</span>
                        {alt.preferred && (
                            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-emerald-700 border border-emerald-200 bg-emerald-50 rounded-full px-2 py-0.5">
                                preferred
                            </span>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

export default ModelRoute;
